module.exports = __webpack_public_path__ + "static/img/error.f0b36f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/error.jpg
// module id = aedp
// module chunks = 11